export default function Icon1() {
    return (
        <svg width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40.3666" cy="39.8656" r="15.9333" stroke="black" strokeWidth="3.33333" />
            <path d="M40.3662 63.4658L40.3662 77.0658" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M56.7666 56.666L68.3666 68.266" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M63.9658 39.8662L77.5658 39.8662" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M56.7666 23.0654L68.3666 11.4654" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M40.3662 16.2656L40.3662 2.66562" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M23.5654 23.0654L11.9654 11.8654" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M16.7666 39.8662H3.1666" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M23.9658 56.666L12.3658 68.266" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
        </svg>
    );
}
